import { render, staticRenderFns } from "./fone.vue?vue&type=template&id=50427b31&"
import script from "./fone.vue?vue&type=script&lang=js&"
export * from "./fone.vue?vue&type=script&lang=js&"
import style0 from "./fone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports